
























import { Component, Vue, Prop } from 'vue-property-decorator'
import { UnitFileData } from '@/api/heritageUnit/unitBase'
import { fileServer, imgServer } from '@/api/common/upload'
import { AttachInfo } from '@/api/common/attach'
import ViewDialog from '@/components/dialog/viewDialog.vue'

@Component({
  components: { ViewDialog }
})
export default class UnitFileDetail extends Vue {
  public name = 'UnitFileDetail'
  public formTitle: string = ''

  public showDialog: boolean = false
  public emptyForm: UnitFileData = {
    Id: 0,
    UnitId: 0,
    FileType: 0, //0:图片 1:图纸
    FileCode: '', // 代码
    FileName: '', // 名称
    AttachId: 0,
    FileCreateDate: new Date(), // 制作日期
    FileMade: '', // 制作人
    FileSpec: '',
    Specification: '',
    NewUserId: 0,
    NewDate: new Date(),

    FileTypeName: '',
    AttachType: 0,
    AttachGuid: '',
    AttInfo: {
      Id: 0,
      TempGuid: '',
      Name: '',
      Ext: '',
      Path: '',
      SavePath: '',
      Size: 0,
      Comments: ''
    }
  }
  public form: UnitFileData = Object.assign({}, this.emptyForm)

  public getOrgFile(f: AttachInfo) {
    return fileServer(f.Id, f.TempGuid, f.Name)
  }
  public getFileUrl(f: AttachInfo) {
    return imgServer(f.Id, f.TempGuid, f.Name)
  }
  public mounted() {
    window.eventBus.$on("openUnitFileDetail", (info: UnitFileData) => {
      this.showDialog = true
      this.setInfo(info)
    });
  }
  public beforeDestroy() {
    window.eventBus.$off("openUnitFileDetail");
  }
  public setInfo(f: UnitFileData) {
    if (f.AttInfo && f.AttInfo.Id > 0) {
      this.form = Object.assign({}, f)
      this.formTitle = f.FileTypeName + '明细-[' + f.FileCode + ']' + f.FileName
    }
    else {
      const msg = `未找到${f.FileTypeName}记录`
      this.$message({
        message: msg,
        type: 'warning'
      })
    }
  }
  public close() {
    this.showDialog = false
    this.form = Object.assign({}, this.emptyForm)
  }
}
